const footer = (menuWrapper: HTMLElement) => {
  const title:HTMLHeadingElement = menuWrapper.querySelector('.footer__menu-title');
  const innerMenu:HTMLElement = menuWrapper.querySelector('.menu');

  if (innerMenu) {
    if (window.innerWidth <= 768) {
      const innerHeight = innerMenu.offsetHeight + 1;
      innerMenu.style.height = '0px';

      title.addEventListener('click', () => {
        if (title.classList.contains('active')) {
          innerMenu.style.height = '0px';
          title.classList.remove('active');
        } else {
          const allMenus = document.querySelectorAll('footer .menu');
          const allTitles = document.querySelectorAll('footer .footer__menu-title');

          allMenus.forEach((menu:HTMLElement) => {
            // eslint-disable-next-line
              menu.style.height = '0px';
          });

          allTitles.forEach((otherTitle:HTMLElement) => {
            if (otherTitle.classList.contains('active')) {
              otherTitle.classList.remove('active');
            }
          });

          innerMenu.style.height = `${innerHeight}px`;
          title.classList.add('active');
        }
      });
    } else {
      const allMenus = document.querySelectorAll('footer .menu');

      allMenus.forEach((menu:HTMLElement) => {
        // eslint-disable-next-line
          menu.style.height = '100%';
      });
    }
  }
};

export default footer;
